export class CashRegisterCloseShiftVendorHandleRequest {
    cashRegisterId?: number;
    requestData?: string;
    responseData?: string;
}  